import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

// Customer-facing npm/Cloudsmith bandwidth analytics. The entitlement token is
// resolved server-side from the account's own npm token, so — unlike the admin
// cloudsmithAnalytics module — no token is ever sent from the client.
export default {
  namespaced: true,

  state: {
    timeSeries: null,
    bandwidthByIp: null,
    loading: false,
    error: null
  },

  getters: {
    timeSeries: (state) => state.timeSeries,
    bandwidthByIp: (state) => state.bandwidthByIp,
    loading: (state) => state.loading,
    error: (state) => state.error
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },

    setError(state, error) {
      state.error = error
    },

    setTimeSeries(state, data) {
      state.timeSeries = data
    },

    setBandwidthByIp(state, data) {
      state.bandwidthByIp = data
    },

    resetState(state) {
      state.timeSeries = null
      state.bandwidthByIp = null
      state.loading = false
      state.error = null
    }
  },

  actions: {
    fetchTimeSeries({ commit }, { interval, start_time, end_time }) {
      return fetch({
        url: '/api/package-bandwidth/time-series',
        params: { interval, start_time, end_time }
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setTimeSeries', data)
          return data
        })
      })
    },

    fetchBandwidthByIp({ commit }, { start_time, end_time }) {
      return fetch({
        url: '/api/package-bandwidth/by-ip',
        params: { start_time, end_time }
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setBandwidthByIp', data)
          return data
        })
      })
    },

    fetchAll({ commit, dispatch }, params) {
      // Clear prior results so the loading state shows (rather than stale data)
      // while a re-query — e.g. after a preset change — is in flight.
      commit('setTimeSeries', null)
      commit('setBandwidthByIp', null)
      commit('setError', null)
      commit('setLoading', true)

      return Promise.all([dispatch('fetchTimeSeries', params), dispatch('fetchBandwidthByIp', params)])
        .catch((error) => {
          commit('setError', error.response ? error.response.data : error.message)
          throw error
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  }
}
